<template>
    <BasicTabs :tabs="tabs" :tab-key="tabKey">
        <slot />
    </BasicTabs>
</template>

<script lang="ts" setup>
import { computed, withDefaults } from "vue";
import { CreditCardIcon, RectangleStackIcon } from "@heroicons/vue/24/solid";
import route from "ziggy-js";
import type TabItem from "@/types/Settings/TabItem";
import { useTranslations } from "@/composables/useTranslations";

interface BillingTabProps {
    tabKey: string;
    showDomainSeatsBilling: boolean;
}

const props = withDefaults(defineProps<BillingTabProps>(), {
    tabKey: "billing",
    showDomainSeatsBilling: false,
});

const { t } = useTranslations();

const tabs = computed<TabItem[]>(() => {
    const items: TabItem[] = [
        {
            title: t("vue.subscriptions"),
            key: "subscriptions",
            icon: CreditCardIcon,
            url: route("billing.subscriptions.index"),
        },
    ];

    if (props.showDomainSeatsBilling === true) {
        items.push({
            title: t("vue.domain_seats_billing"),
            key: "domain-seats-billing",
            icon: RectangleStackIcon,
            url: route("billing.subscriptions.domain-seats"),
        });
    }

    return items;
});
</script>
